import { ScrollView, Text, View, useColorScheme } from 'react-native';
import React, { Suspense, memo, lazy } from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import MenuIconCard from '@components/Global/MenuIconCard';
import { useTranslation } from 'react-i18next';
import { XStack } from 'tamagui';

const AnimatedLottieView = lazy(() => import('@utils/lottieAnimation'));

const LazyLottieView = (props) => (
  <Suspense fallback={<View />}>
    <AnimatedLottieView {...props} />
  </Suspense>
);

const SettingsMenu = ({ navigation }) => {
  const { t } = useTranslation();
  return (
    <DefaultScreen style={{ paddingLeft: 2, paddingRight: 3 }}>
      <XStack flexWrap='wrap' gap={20} columnGap={20} style={{ gap: 5, marginBottom: 150, alignSelf: 'stretch', flexDirection: 'row', flexWrap: 'wrap' }}>
        <MenuIconCard pressFunction={() => {
          navigation.navigate('Profile')
        }} subtitle={`${t('BrowseDataSub')}
          `} cardTitle={`${t('Profile')}`}>
          <LazyLottieView source={require('@assets/animations/magnifExample.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => {
          navigation.navigate('Upgrade')
        }} subtitle={`${t('UpgradeSub')}
          `} cardTitle={`${t('Upgrade')}`}>
          <LazyLottieView source={require('@assets/animations/111742-diamond-upgrade-reward-animation.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('Context')} subtitle={`${t('ContextSub')}`} cardTitle={`${t('Context')}`}>
          <LazyLottieView source={require('@assets/animations/star.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('Language')} subtitle={`${t('changeLangSub') || 'Change your preferred language'}`} cardTitle={`${t('changeLang') || 'Language'}`}>
          <LazyLottieView source={require('@assets/animations/wired-flat-27-globe.json')} loop={false} style={{ width: '100%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
      </XStack>
    </DefaultScreen >
  )
}
export default memo(SettingsMenu);